import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Hook to get query params from location as an url search params object
 */
export function useQueryParams() {
  const { search } = useLocation();

  return useMemo(() => new URLSearchParams(search), [search]);
}
